// libs
import React from 'react';
import ReactDOM from 'react-dom/client';
// layouts
import App from './layouts/App';
// helpers
import { EnvironmentEnum, getEnvironmentViaHostname } from './helpers/env';
/**
 * This is because of the prefix rules defined on redirection policy
 * It redirects 404 /instamart/* requests to /instamart/#!/*
 * And on client side we remove #! to allow react router to work
 */
if (getEnvironmentViaHostname() === EnvironmentEnum.PRODUCTION) {
    const path = (/#!(\/.*)$/.exec(location.hash) || [])[1];
    history.pushState({}, '', '/instamart' + (path || ''));
}
const element = document.getElementById('root');
const root = ReactDOM.createRoot(element);
root.render(React.createElement(App, null));
